var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bookmark-wrapper"},[(_vm.isFavourite)?_c('div',{staticClass:"btn-bookmark"},[(
        _vm.dashboard_access &&
        _vm.dashboard_access.some(
          function (el) { return el.type === 'social' && el.access === '1'; }
        )
      )?_c('i',{staticClass:"material-icons reaction-icn-1",on:{"click":function($event){return _vm.handleUnsave(_vm.id)}}},[_vm._v("bookmark")]):_c('i',{staticClass:"material-icons disabled-icon"},[_vm._v("bookmark")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("Unsave Post")])],1):_c('div',{staticClass:"btn-bookmark"},[(
        _vm.dashboard_access &&
        _vm.dashboard_access.some(
          function (el) { return el.type === 'social' && el.access === '1'; }
        )
      )?_c('i',{staticClass:"material-icons reaction-icn-1",on:{"click":function($event){return _vm.handleSave(_vm.id)}}},[_vm._v("bookmark_border")]):_c('i',{staticClass:"material-icons disabled-icon"},[_vm._v("bookmark_border")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("Save Post")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e314b8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/newsfeed/bookmark.vue
// module id = null
// module chunks = 